<ng-template>
   <div lcsSingleSelectPanel [visible]="true">
      <ng-content></ng-content>
   </div>
</ng-template>
